import { Model } from 'core/models';
import { LoginConfigurationContent } from './LoginConfigurationContent';
import { Status } from './Status';

export class LoginConfiguration extends Model {

  public id?: number;


  public code?: string;


  public name?: string;


  public statusId?: number;


  public status?: Status;

  public loginConfigurationContents?: LoginConfigurationContent[];
}
